import "./Checkbox.scss";

const Multicheckbox = ({ label, required, inputs }) => {
  return (
    <div className="Checkboxes">
      <label htmlFor="tag">
        <span className="Checkboxes__label">{label}</span>

        <div className="Checkboxes__checks Checkboxes__checks">
          {inputs.map((input, i) => (
            <div key={i}>
              {input.name ? (
                <div className="Checkboxes__checks--group">
                  {input.icon}
                  <input
                    type="checkbox"
                    value={input.value}
                    onChange={input.onChange}
                    checked={input.checked}
                    required={required}
                    style={{ margin: 0 }}
                  />
                </div>
              ) : (
                <div className="Checkboxes__checks--group">
                  <input
                    type="checkbox"
                    value={input.value}
                    onChange={input.onChange}
                    checked={input.checked}
                    required={required}
                    style={{ margin: 0 }}
                  />
                  <span style={{ marginLeft: 5, fontSize: "10px" }}>
                    {input.value}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      </label>
    </div>
  );
};

export default Multicheckbox;
